// extracted by mini-css-extract-plugin
module.exports = {"heading":"SuggestedCategories_heading__x8awT","list":"SuggestedCategories_list__0tuYf"};